import { GetVehicleTransactionModel } from "@factory/model/query-model-vehicle-transaction";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { vehicleTransactionFormDefault } from "./form.default";
import { VehicleTransactionFormSchema } from "./form.rule";

export const useFormDefaultVehicleTransaction = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetVehicleTransactionModel | undefined) => {
    return !cachedValue
      ? vehicleTransactionFormDefault
     : ({
        tenant: cachedValue.tenant,
        vehicle: cachedValue.vehicle,
        transaction: cachedValue.transaction,
        userCode: cachedValue.user_code,
      } as VehicleTransactionFormSchema);
  };

  return {
    getDefault,
  };
};
